<template>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <!--分类名称-->
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="formData.name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="键值" prop="key_name" :label-width="formLabelWidth">
        <el-input v-model="formData.key_name" placeholder="请输入"></el-input>
      </el-form-item>

      <!--排序-->
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model="formData.sort" placeholder="请输入排序" type="number"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TypeApi from '@/api/study/type.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        /*分类名称*/
        name: '',
        key_name: '',
        /*是否显示*/
        status: 1,
        /*排序*/
        sort: 100,
      },
      /*验证规则*/
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        key_name: [{ required: true, message: '请输入键值', trigger: 'blur' }],
      },
      /*当前父集ID*/
      parentsVal: [],
      /*分类列表*/
      cateList: [],
      /*排序*/
      srot: '1',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*展示数据*/
      propsParam: {
        label: 'name',
        value: 'category_id',
        checkStrictly: true
      }
    };
  },
  props: {
    open_add: Boolean,
    rawData: Array,
    selectModel: Object
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          TypeApi.add(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/type/part/Add.vue